import React from "react";
import { Modal } from "sprint-common-web";

import { OrderListingItem } from "../../OrderListingItem";
import { UpdateOrderDeliveryFolderForm } from "./UpdateOrderDeliveryFolderForm";

export interface UpdateOrderDeliveryFolderModalProps {
    isOpen: boolean;
    item: OrderListingItem;
    onCancel(): void;
    onSubmit(): void;
}

export const UpdateOrderDeliveryFolderModal: React.VFC<UpdateOrderDeliveryFolderModalProps> = ({
    isOpen,
    item,
    onCancel,
    onSubmit
}: UpdateOrderDeliveryFolderModalProps) => {
    return (
        <Modal headerText="Update Delivery Folder" onDismiss={onCancel} isBlocking={true} isOpen={isOpen}>
            <UpdateOrderDeliveryFolderForm item={item} onCancel={onCancel} onSubmit={onSubmit} />
        </Modal>
    );
};
